// ContactPage.jsx
import React from 'react';
// import emailjs from 'emailjs-com';
import Footer from './Footer';
import ContactIMG1 from '../assets/ContactIMG1.png';
import ContactIMG2 from '../assets/ContactIMG2.jpg';
import { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import QRcode from '../assets/QRcode.jpg';



const ContactPage = () => {

    const [isSubmitted, setIsSubmitted] = useState(false);


    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
        setIsSubmitted(true); // disable the button immediately

        emailjs
            .sendForm('service_yalh5wy', 'template_6fiq0l4', form.current, {
                publicKey: '_IokqDxhynHK8phwD',
            })
            .then(
                () => {
                    alert('Submitted successfully!');
                    form.current.reset();         // Optional: clear form fields
                    setIsSubmitted(true);         // Keep button disabled
                },
                (error) => {
                    console.log('FAILED...', error.text);
                    setIsSubmitted(false);        // Re-enable button on failure
                }
            );
    };


    return (
        <>
            <style>{`
                .hero-section {
                    background-size: cover;
                    background-position:center;
                    height: 55vh;
                    display: flex;
                    align-items: center;
                    justify-content: center; 
                    flex-direction: column;
                    position: relative;
                }

                .arrow-container {
                    margin-top: 10px;
                    height: 40px;
                    position: relative;
                    overflow: hidden;
                    opacity: 1;
                    transition: opacity 0.5s ease;
                }

                .animated-arrow {
                    width: 0;
                    height: 0;
                    border-left: 12px solid transparent;
                    border-right: 12px solid transparent;
                    border-top: 20px solid white;
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%) translateY(10px);
                    animation: bounce 1s infinite;
                }

                @keyframes bounce {
                    0%, 100% {
                        transform: translateX(-50%) translateY(10px);
                    }
                    50% {
                        transform: translateX(-50%) translateY(0px);
                    }
                }
            `}</style>

            <div className="hero-section" style={{ backgroundImage: `url(${ContactIMG1})` }}>
                <div className="container text-center hero-content">
                    <h1 className="text-white fw-bold" style={{ fontSize: "6em" }}>Contact us</h1>
                    <div className="arrow-container">
                        <div className="animated-arrow"></div>
                    </div>
                </div>
            </div>

            <div className="py-5" style={{ backgroundColor: '#f9f9f9' }}>
                <div className="container">
                    <div className="row align-items-start">
                        <div className="col-md-6 mb-4 mb-md-0">
                            <h2 className="fw-bold mb-3 text-start" style={{ fontSize: "2.5rem", color: "rgb(3, 161, 204)" }}>We would love to hear from You</h2>
                            <p className="text-muted mb-4 text-start">
                                Have any queries or simply need to enquire about any of our services? Feel free to get in touch. You can call us for urgent appointments or submit the form here for any other queries you may have.
                            </p>

                            <ul className="list-unstyled">
                                {/* <li className="mb-3 d-flex align-items-center">
                                    <span className="me-3 text-white rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '36px', height: '36px', backgroundColor: "rgb(4,180,228)" }}>
                                        <i className="fas fa-map-marker-alt"></i>
                                    </span>
                                    <div className='text-start'>
                                        <a href="https://goo.gl/maps/q3AGgDLQ5oyFgVvm6" target="_blank" rel="noreferrer" className="text-decoration-underline text-dark fw-bolder text-start">
                                            Warals Technology
                                        </a><br />
                                        G 35, Basement, Near Kalindi Kunj, New Delhi - 110025 <br />
                                        <strong>Corporate Office Address- </strong> <br />
                                        N-18, South Extension Part-1 New Delhi
                                    </div>
                                </li> */}
                                <li className="mb-3 d-flex align-items-center">
                                    <span className="me-3 text-white rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '36px', height: '36px', backgroundColor: "rgb(4,180,228)" }}>
                                        <i className="fas fa-phone-alt"></i>
                                    </span>
                                    <a href="tel:+919871115060" className="text-dark fw-semibold">+919871115060</a>
                                </li>

                                <li className="d-flex align-items-center">
                                    <span className="me-3 text-white rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '36px', height: '36px', backgroundColor: "rgb(4,180,228)" }}>
                                        <i className="fas fa-envelope"></i>
                                    </span>
                                    <a href="mailto:info@warals.com" className="text-dark fw-semibold">info@warals.com</a>
                                </li>
                            </ul>
                            <div className="d-flex justify-content-start mt-3">
  <img
    src={QRcode}
    alt="QR Code"
    className="img-fluid"
    style={{ maxWidth: '250px', height: 'auto',  borderRadius: '15px'  }}
  />
</div>

                        </div>

                        <div className="col-md-6">
                            <div className="p-4 p-lg-5 rounded-4 shadow bg-white" style={{ border: '1px solid rgba(0,0,0,0.1)' }}>
                                <h3 className="fw-bold mb-4 text-center" style={{
                                    color: 'rgb(4,180,228)',
                                    fontSize: '1.8rem',
                                    letterSpacing: '0.5px'
                                }}>
                                    Get in Touch
                                </h3>
                                <form ref={form} onSubmit={sendEmail}>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control border border-2 py-3 px-3 rounded-3"
                                                placeholder="Your Name*"
                                                style={{ fontSize: '1.05rem' }}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="email"
                                                name="email"
                                                className="form-control border border-2 py-3 px-3 rounded-3"
                                                placeholder="Email Address*"
                                                style={{ fontSize: '1.05rem' }}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="tel"
                                                name="phone"
                                                className="form-control border border-2 py-3 px-3 rounded-3"
                                                placeholder="Mobile Number*"
                                                style={{ fontSize: '1.05rem' }}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <select
                                                name="interested_in"
                                                className="form-select border border-2 py-3 px-3 rounded-3"
                                                style={{ fontSize: '1.05rem' }}
                                                required
                                            >
                                                <option value="">Interested In*</option>
                                                <option value="School Management System">School Management System</option>
                                                <option value="Institute Management System">Institute Management System</option>
                                                <option value="Learning Management System">Learning Management System</option>
                                                <option value="Website Development">Website Development</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <select
                                                name="budget"
                                                className="form-select border border-2 py-3 px-3 rounded-3"
                                                style={{ fontSize: '1.05rem' }}
                                            >
                                                <option value="">Your Budget</option>
                                                <option value="Less than ₹25,000">Less than ₹25,000</option>
                                                <option value="₹25,000 - ₹50,000">₹25,000 - ₹50,000</option>
                                                <option value="₹50,000 - ₹1,00,000">₹50,000 - ₹1,00,000</option>
                                                <option value="₹1,00,000 - ₹1,50,000">₹1,00,000 - ₹1,50,000</option>
                                                <option value="More than ₹1,50,000">More than ₹1,50,000</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                name="WhatsApp"
                                                className="form-control border border-2 py-3 px-3 rounded-3"
                                                placeholder="WhatsApp No.*"
                                                style={{ fontSize: '1.05rem' }}
                                                required
                                            />
                                        </div>
                                        <div className="col-12">
                                            <textarea
                                                name="message"
                                                className="form-control border border-2 py-3 px-3 rounded-3"
                                                rows="4"
                                                placeholder="Your Message (optional)"
                                                style={{ fontSize: '1.05rem', minHeight: '120px' }}
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div className="form-check text-start my-4">
                                        <input
                                            className="form-check-input me-2"
                                            type="checkbox"
                                            id="notRobot"
                                            style={{ width: '1.1em', height: '1.1em' }}
                                            required
                                        />
                                        <label className="form-check-label" htmlFor="notRobot" style={{ fontSize: '1.05rem' }}>
                                            I'm not a robot
                                        </label>
                                    </div>

                                    <div className="text-center">
                                        <button
                                            type="submit"
                                            disabled={isSubmitted}
                                            className="btn text-white px-5 py-3 fw-semibold"
                                            style={{
                                                backgroundColor: isSubmitted ? '#ccc' : 'rgb(4,180,228)',
                                                borderRadius: '12px',
                                                fontSize: '1.1rem',
                                                transition: 'all 0.3s ease',
                                                width: '100%',
                                                maxWidth: '300px',
                                                cursor: isSubmitted ? 'not-allowed' : 'pointer'
                                            }}
                                            onMouseOver={(e) => {
                                                if (!isSubmitted) e.target.style.backgroundColor = '#00a8d4';
                                            }}
                                            onMouseOut={(e) => {
                                                if (!isSubmitted) e.target.style.backgroundColor = 'rgb(4,180,228)';
                                            }}
                                        >
                                            {isSubmitted ? "Submitted" : "Send Message"}
                                        </button>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="mt-5 container text-center">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d14016.42562878574!2d77.222909!3d28.5665673!3m2!1i1024!2i768!4f13.1!2m1!1sN%2018%20Lower%20Ground%20Floor%20South%20Extension%201%20Block%20H%20New%20Delhi%20Delhi%20110049!5e0!3m2!1sen!2sin!4v1768566091374!5m2!1sen!2sin"
                            style={{ border: 0, width: "80vw", height: "60vh" }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default ContactPage;
